var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is.loaded)?_c('app-wrapper',[_c('com-transitions'),_c('com-cta'),_c('com-adverts'),_c('com-recent')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }